import Text from '../../../components/Text.js';
import React from 'react';
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from '../../../components/Checkbox.js';
import TextInput from '../../../components/TextFields/TextInput.js';
import DateInput from '../../../components/TextFields/DateInput.js';
import i18n from '../../../localization/i18n.js';
import tokens from '../../../localization/tokens.js';

/**
 * Agreement component for confirming a purchase and providing necessary information.
 *
 * @component
 * @param {boolean} isMasterSite - Indicates whether used in master site or control site.
 * @param {Object} member - Information about the member making the purchase.
 * @param {Object} product - Information about the selected product.
 * @param {Object} purchaseData - Data related to the purchase, including signage information.
 * @param {Function} savePurchaseData - Function to save updated purchase data.
 * @param {Object} confirmationErrors - Errors related to confirmation inputs.
 * @returns {JSX.Element} - The rendered Agreement component.
 * @constructor
 */
const Agreement = ({
  isMasterSite,
  member,
  product,
  purchaseData,
  savePurchaseData,
  confirmationErrors
}) => /*#__PURE__*/React.createElement(React.Fragment, null, !isMasterSite && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
  small: true
}, i18n.t(tokens.labels.marketplace.confirmPurchaseInfo)), /*#__PURE__*/React.createElement(TextInput, {
  label: i18n.t(tokens.labels.password),
  value: purchaseData.signage.password,
  onChange: e => {
    savePurchaseData({
      ...purchaseData,
      password: e.target.value.toString()
    });
  },
  secure: true,
  error: confirmationErrors.password,
  fullWidth: true,
  autofocus: true
})), /*#__PURE__*/React.createElement(TextInput, {
  label: i18n.t(tokens.labels.yourName),
  fullWidth: true,
  value: purchaseData.signage.name,
  onChange: e => {
    savePurchaseData({
      ...purchaseData,
      signage: {
        ...purchaseData.signage,
        name: e.target.value.toString()
      }
    });
  },
  error: confirmationErrors.name
}), /*#__PURE__*/React.createElement(TextInput, {
  label: i18n.t(tokens.labels.signature),
  fullWidth: true,
  value: purchaseData.signage.signature,
  onChange: e => {
    savePurchaseData({
      ...purchaseData,
      signage: {
        ...purchaseData.signage,
        signature: e.target.value.toString()
      }
    });
  },
  isSignature: true,
  error: confirmationErrors.signature
}), /*#__PURE__*/React.createElement(DateInput, {
  label: i18n.t(tokens.labels.account.datedOnYYYYMMDD),
  fullWidth: true,
  value: purchaseData.signage.datedOn,
  onChange: e => {
    savePurchaseData({
      ...purchaseData,
      signage: {
        ...purchaseData.signage,
        datedOn: e.target.value.toString()
      }
    });
  },
  error: confirmationErrors.datedOn
}), /*#__PURE__*/React.createElement(FormControlLabel, {
  control: /*#__PURE__*/React.createElement(Checkbox, {
    checked: purchaseData.signage.acceptedTerms,
    onChange: () => savePurchaseData({
      ...purchaseData,
      signage: {
        ...purchaseData.signage,
        acceptedTerms: !purchaseData.signage.acceptedTerms,
        timestampOfAcceptance: new Date().getTime() / 1000
      }
    }),
    value: "Agreement",
    color: "secondary"
  }),
  label: /*#__PURE__*/React.createElement(React.Fragment, null, product.type.toUpperCase() === 'VOLUNTARY' ? /*#__PURE__*/React.createElement(Text, {
    small: true,
    light: true,
    margin: "20px 0 0 0"
  }, i18n.t(tokens.labels.marketplace.withdrawalAgreementInfoVoluntary)) : /*#__PURE__*/React.createElement(Text, {
    small: true,
    light: true
  }, i18n.t(tokens.labels.marketplace.withdrawalAgreementInfoOptional)), product.legalClausesToAccept.length > 0 && product.legalClausesToAccept.map(clause => /*#__PURE__*/React.createElement(Text, {
    small: true,
    light: true,
    margin: "5px 0 0 0",
    key: clause[member.language]
  }, clause[member.language])))
}), confirmationErrors.agreement && /*#__PURE__*/React.createElement(Text, {
  small: true,
  color: "red",
  align: "center"
}, i18n.t(tokens.labels.banking.youMustAcceptTermsError)));
export default Agreement;